import { State, Selector, Action, StateContext, Store } from '@ngxs/store';
import { catchError, map, tap } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { GetInteractionTagLists, SaveCxInteraction, PushInteractionAlert } from './cx-interaction.action';
import { CxInteractionService } from 'app/services/cx-interaction/cx-interaction.service';
import { TagLists } from 'app/models/cx-interaction/cx-interaction-tag-list.interface';
import { CxInteraction } from 'app/models/cx-interaction/cx-interaction.model';
import { of } from 'rxjs';
import { Alert } from 'app/models/dto/alert.model';

export interface CXInteractionStateModel {
    cxInteraction: CxInteraction | any;
    tagLists: TagLists[];
    alerts: Alert[] | [];
  }
  
  @State<CXInteractionStateModel>({
    name: 'cxInteraction',
    defaults: {
      cxInteraction: null,
      tagLists: [],
      alerts: [],
    }
  })
  
  @Injectable()
  
  export class CXInteractionState {

    /**
     * returns lists of tags
     *
     * @param state
     */
    @Selector()
    static tagLists(state: CXInteractionStateModel) {
      return state.tagLists;
    }

    /**
     * returns all alerts
     *
     * @param state
     */
    @Selector()
    static alerts(state: CXInteractionStateModel) {
      return state.alerts;
    }

    constructor(
        private cxInteractionService: CxInteractionService,
        private store: Store
      ) { }


    /**
     * Get list of tags for CxInteraction form
     */  
    @Action(GetInteractionTagLists)
    getInteractionTagLists({patchState }: StateContext<CXInteractionStateModel>, {}: GetInteractionTagLists) {
      return this.cxInteractionService.getInteractionTagLists().pipe(catchError(err => throwError(() => err)),
        map(data => {
          patchState({
            tagLists: data['lists']
          });
        })
      );
    }

    @Action(SaveCxInteraction)
    saveCxInteraction(
      { patchState }: StateContext<CXInteractionStateModel>,
      {cxInteractionInfo, form, directive, cxComponent}: SaveCxInteraction
    ) {
      return this.cxInteractionService.saveCxInteraction(cxInteractionInfo).pipe(catchError(err => {
          const errorText = err.message ? err.message : 'Failed to save interaction.';
          this.store.dispatch(new PushInteractionAlert('error', errorText));
          cxComponent.processing = false;
          return of();
      }), tap(interaction => {
          patchState({
              cxInteraction: interaction,
          });
          this.store.dispatch(new PushInteractionAlert(
              'success',
              'The interaction was created successfully.'
          ));
          directive.resetForm();
          form.reset();
          cxComponent.resetDefaultFormSettings();

      }));
    }  

    @Action(PushInteractionAlert)
    pushInteractionAlert({ getState, patchState }: StateContext<CXInteractionStateModel>, { alertLevel, message }: PushInteractionAlert) {
      patchState({ alerts: [ ...getState().alerts, { level: alertLevel, message, errorId: getState().alerts.length + 1 } ]});
    }

  }
